export default {
	"pages": {
		"root": {
			"id": "root",
			"pageUrl": "root",
			"name": "root",
			"children": [
				"66f6d1359710450018a331ba",
				"66f6d1359710450018a331bd",
				"670bf015e5d277001898945e",
				"670bf0609335410018c70fb2"
			]
		},
		"66f6d1359710450018a331ba": {
			"id": "66f6d1359710450018a331ba",
			"name": "404",
			"pageUrl": "404"
		},
		"66f6d1359710450018a331bd": {
			"id": "66f6d1359710450018a331bd",
			"name": "Login",
			"pageUrl": "index"
		},
		"670bf015e5d277001898945e": {
			"id": "670bf015e5d277001898945e",
			"pageUrl": "login",
			"name": "Orders-Managers"
		},
		"670bf0609335410018c70fb2": {
			"id": "670bf0609335410018c70fb2",
			"pageUrl": "orders-customers",
			"name": "Orders-Add"
		}
	},
	"mode": "production",
	"projectType": "create-react-app",
	"site": {
		"styles": {},
		"seo": {}
	}
}